import i18n from 'app/i18n';
import api from '../api';


export const PASSAGES_REQUEST = 'PASSAGES_REQUEST';
export const PASSAGES_SUCCESS = 'PASSAGES_SUCCESS';
export const PASSAGES_FAILURE = 'PASSAGES_FAILURE';


const passagesRequest = () => ({
  type: PASSAGES_REQUEST,
});

const passagesSuccess = data => ({
  type: PASSAGES_SUCCESS,
  payload: data,
});

const passagesFailure = errString => ({
  type: PASSAGES_FAILURE,
  payload: { err: errString },
});


/**
* Запрос данных для приложения "Проходы"
* Для всех детей к текущей дате или диапазону
*/
export const fetchPassages = (id, date, date2, offset, limit) => (
  async (dispatch) => {
    dispatch(passagesRequest());
    const params = { date, limit };
    if (id) {
      params.student_id = id;
    }
    if (date2) {
      params.date2 = date2;
    }
    if (offset) {
      params.offset = offset;
    }
    try {
      const passages = await api('cabinet/passages', 'get', { params });
      dispatch(passagesSuccess(passages.data));
    } catch (error) {
      dispatch(passagesFailure(i18n.t('app:request_passes_failed')));
    }
  }
);
